export default {
  computed: {
    accessibleMenuItems() {
      if (!this.currentRole) {
        return [];
      }
      const hideSubscriptionIdList = [12, 16];
      const hideMenuLabelList = ['INTEGRATIONS', 'APPLICATIONS'];
      return this.menuConfig.menuItems
        .filter(
          menuItem =>
            window.roleWiseRoutes[this.currentRole].indexOf(
              menuItem.toStateName
            ) > -1
        )
        .filter(menuEl => {
          if (hideSubscriptionIdList.includes(this.subscriptionPlanId)) {
            return !hideMenuLabelList.includes(menuEl.label);
          }
          return true;
        })
        .filter(el => {
          // apply different condition to filter submenu
          // hide llm_chatbot if feature not exist in account
          if (
            el.toStateName === 'llm_bot_list' &&
            !this.currentAccount?.features?.llm_chatbot
          ) {
            return false;
          }

          // hide campaign form  'campaign_form_list'
          if (
            el.toStateName === 'campaign_form_list' &&
            !this.currentAccount?.features?.forms
          ) {
            return false;
          }

          return true;
        });
    },
  },
};
